import Vue from 'vue';
import Router, { Route } from 'vue-router';
import store from '@/store/index';
import storage from 'baimahu/storage';

import AccountSetting from '@/view/setting/account-setting.vue';
import ActivityIntegration from '@/view/activity/integration.vue';
import ActivityIntegrationRank from '@/view/activity/integration-rank.vue';
import ActivityList from '@/view/activity/list.vue';
import ActivityPage from '@/view/activity/page.vue';
import ActivityTarget from '@/view/activity/target.vue';
import ActivityWare from '@/view/activity/ware.vue';
import ActivityWareRank from '@/view/activity/ware-rank.vue';
import AddBargainFirst from '@/view/promotion/bargain/add-bargain-first.vue';
import AddBargainSecond from '@/view/promotion/bargain/add-bargain-second.vue';
import AddCommunity from '@/view/operation/add-community.vue';
import AddDesignWorks from '@/view/operation/add-design-works.vue';
import AddTemplateRoom from '@/view/operation/add-template-room.vue';
import SenceExample from '@/view/operation/real-sence-example.vue';
import AddExample from '@/view/operation/add-sence-example.vue';
import AddSetMeal from '@/view/operation/add-set-meal.vue';
import Authorize from '@/view/setting/authorize.vue';
import Award from '@/view/activity/award.vue';
import Bargain from '@/view/promotion/bargain/bargain.vue';
import BargainData from '@/view/promotion/bargain/bargain-data.vue';
import BasicInfo from '@/view/setting/basic-info.vue';
import BringOrder from '@/view/activity/bring-order.vue';
import Browse from '@/view/activity/browse.vue';
import CarouselDetail from '@/view/operation/carousel-detail.vue';
import CarouselList from '@/view/operation/carousel-list.vue';
import ConfigBase from '@/view/activity/config-first.vue';
import ConfigPage from '@/view/activity/config-second.vue';
import ConfigShareAward from '@/view/activity/config-third.vue';
import CommunityTemplate from '@/view/operation/community-template.vue';
import CommunityList from '@/view/operation/community-list.vue';
import DataDetails from '@/view/activity/details.vue';
import DesignWorks from '@/view/operation/design-works.vue';
import EditAccount from '@/view/setting/edit-account.vue';
import FinanceDetail from '@/view/finance/detail.vue';
import FinanceList from '@/view/finance/list.vue';
import FinanceContract from '@/view/finance/contract-list.vue';
import Home from '@/view/home/index.vue';
import Login from '@/view/passport/login.vue';
import Login2 from '@/view/passport/login2.vue';
import OrderList from '@/view/order/list.vue';
import PromotionCoupon from '@/view/promotion/coupon/list.vue';
import PromotionCouponFirst from '@/view/promotion/coupon/config-first.vue';
import PromotionCouponSecond from '@/view/promotion/coupon/config-second.vue';
import PaymentBinding from '@/view/setting/payment-binding.vue';
import Region from '@/view/setting/region-management.vue';
import Release from '@/view/setting/release.vue';
import RuanSetMeal from '@/view/operation/ruan-set-meal.vue';
import SaleList from '@/view/sale/list.vue';
import SaleStockManage from '@/view/sale/stock-manage.vue';
import SignUp from '@/view/activity/sign-up.vue';
import StyleList from '@/view/operation/style-list.vue';
import TradeSetting from '@/view/setting/trade-setting.vue';
import User from '@/view/setting/user.vue';
import UserDetail from '@/view/user/detail.vue';
import HomePage from '@/view/operation/home-page.vue';
import HomePageStandard from '@/view/operation/home-page-standard.vue';
import HouseKeeper from '@/view/setting/housekeeper.vue';
import UserList from '@/view/user/list.vue';
import OrderUserList from '@/view/user/order-user.vue';
import SignedUser from '@/view/user/signed-user.vue';
import WareEditFirst from '@/view/ware/edit-first.vue';
import WareEditSecond from '@/view/ware/edit-second.vue';
import WareList from '@/view/ware/list.vue';
import CategoryList from '@/view/ware/category-list.vue';
import WareRedeemCode from '@/view/ware/redeem-code.vue';
import Watch from '@/view/activity/watch.vue';
import SelectMerchant from '@/view/passport/select-merchant.vue';
Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: Home },
    { path: '/activity/activity-integration', component: ActivityIntegration, name: '活动' },
    {
      path: '/activity/activity-integration-rank',
      component: ActivityIntegrationRank,
      name: '活动',
    },
    { path: '/activity/activity-page', component: ActivityPage, name: '活动' },
    { path: '/activity/activity-target', component: ActivityTarget, name: '活动' },
    { path: '/activity/activity-ware', component: ActivityWare, name: '活动' },
    { path: '/activity/activity-ware-rank', component: ActivityWareRank, name: '活动' },
    { path: '/activity/award', component: Award, name: '活动' },
    { path: '/activity/bring-order', component: BringOrder, name: '活动' },
    { path: '/activity/browse', component: Browse, name: '活动' },
    { path: '/activity/config-first', component: ConfigBase, name: '活动' },
    { path: '/activity/config-second', component: ConfigPage, name: '活动' },
    { path: '/activity/config-third', component: ConfigShareAward, name: '活动' },
    { path: '/activity/details', component: DataDetails, name: '活动' },
    { path: '/activity/list', component: ActivityList, name: '活动' },
    { path: '/activity/sign-up', component: SignUp, name: '活动' },
    { path: '/activity/watch', component: Watch, name: '活动' },
    { path: '/finance/detail', component: FinanceDetail, name: '财务' },
    { path: '/finance/list', component: FinanceList, name: '财务' },
    { path: '/finance/contract-list', component: FinanceContract, name: '财务' },
    { path: '/home/index', component: Home },
    { path: '/login', component: Login, meta: { ignoreLoginStatus: true } },
    { path: '/login-mendian', component: Login2, meta: { ignoreLoginStatus: true } },
    {
      path: '/select-merchant',
      component: SelectMerchant,
      meta: { layout: 'select_merchant', ignoreLoginStatus: true },
    },
    { path: '/operation/add-community', component: AddCommunity, name: '运营' },
    { path: '/operation/add-set-meal', component: AddSetMeal, name: '运营' },
    { path: '/operation/add-design-works', component: AddDesignWorks, name: '运营' },
    { path: '/operation/add-template-room', component: AddTemplateRoom, name: '运营' },
    { path: '/operation/community-template', component: CommunityTemplate, name: '运营' },
    { path: '/operation/community-list', component: CommunityList, name: '运营' },
    { path: '/operation/sence-example', component: SenceExample, name: '运营' },
    { path: '/operation/add-sence-example', component: AddExample, name: '运营' },
    { path: '/operation/ruan-set-meal', component: RuanSetMeal, name: '运营' },
    { path: '/operation/design-works', component: DesignWorks, name: '运营' },
    { path: '/operation/style-list', component: StyleList, name: '运营' },
    { path: '/order/list', component: OrderList, name: '订单' },
    { path: '/promotion/bargain', component: Bargain, name: '营销' },
    { path: '/promotion/bargain/add-first', component: AddBargainFirst, name: '营销' },
    { path: '/promotion/bargain/add-second', component: AddBargainSecond, name: '营销' },
    { path: '/promotion/bargain/bargain-data', component: BargainData, name: '营销' },
    { path: '/promotion/coupon', component: PromotionCoupon, name: '营销' },
    { path: '/promotion/coupon/config-first', component: PromotionCouponFirst, name: '营销' },
    {
      path: '/promotion/coupon/config-second/:id',
      component: PromotionCouponSecond,
      name: '营销',
    },
    { path: '/sale/list', component: SaleList, name: '分销' },
    { path: '/sale/stock-manage', component: SaleStockManage, name: '分销' },
    { path: '/setting/authorize', component: Authorize, name: '设置' },
    { path: '/setting/account', component: AccountSetting, name: '设置' },
    { path: '/setting/basic-info', component: BasicInfo, name: '设置' },
    { path: '/operation/carousel-detail/:id', component: CarouselDetail, name: '运营' },
    { path: '/operation/carousel-list', component: CarouselList, name: '运营' },
    { path: '/setting/payment', component: PaymentBinding, name: '设置' },
    { path: '/setting/release', component: Release, name: '设置' },
    { path: '/setting/region', component: Region, name: '设置' },
    { path: '/setting/trade', component: TradeSetting, name: '设置' },
    { path: '/setting/user', component: User, name: '设置' },
    { path: '/setting/housekeeper', component: HouseKeeper, name: '设置' },
    { path: '/setting/edit-account', component: EditAccount, name: '设置' },
    { path: '/operation/home-page', component: HomePage, name: '运营' },
    { path: '/operation/home-page-standard', component: HomePageStandard, name: '运营' },
    { path: '/user/user-list', component: UserList, name: '用户' },
    { path: '/user/user-detail', component: UserDetail, name: '用户' },
    { path: '/user/order-user', component: OrderUserList, name: '用户' },
    { path: '/user/signed-user', component: SignedUser, name: '用户' },
    { path: '/ware/edit-first', component: WareEditFirst, name: '商品' },
    { path: '/ware/edit-second/:id', component: WareEditSecond, name: '商品' },
    { path: '/ware/list', component: WareList, name: '商品' },
    { path: '/ware/category-list', component: CategoryList, name: '商品' },
    { path: '/ware/redeem-code/:id', component: WareRedeemCode, name: '商品' },
    { path: '*', redirect: '/' },
  ],
});

const { state } = store;
router.beforeEach((to: Route, from: Route, next: any) => {
  if (to.path === '/login') {
    sessionStorage.removeItem('merchant_type');
  }
  const auth_set_list = storage.getItem('profile') ? storage.getItem('profile').auth_set_list : '';
  if (sessionStorage.getItem('merchant_type') && auth_set_list !== 'all') {
    const str_router_arr: any = [];
    state.menu.forEach((item: any) => {
      (router.options.routes as any).forEach((item2: any) => {
        if (item2.name === item.name) {
          str_router_arr.push(item2.path);
        }
      });
    });
    str_router_arr.push('/select-merchant', '/login-mendian', '/home/index');
    if (str_router_arr.indexOf(to.path) === -1 && to.path !== '/login-mendian') {
      if (to.params.id) {
        const str = to.path.slice(0, to.path.length - 2);
        if (str_router_arr.indexOf(str) !== -1) {
          next();
        }
      } else {
        next('/home/index');
      }
    }
  }
  const is_logged_on: boolean = state.is_logged_on;
  if (is_logged_on || to.meta.ignoreLoginStatus) {
    next();
  } else {
    if (sessionStorage.getItem('merchant_type')) {
      next('/login-mendian');
    } else {
      next('/login');
    }
  }
  const profile = storage.getItem('profile') || {};
  const activated_module: any = profile.activated_module;
  const activity_module_id = 1;
  if (activated_module) {
    if (is_logged_on && !activated_module.includes(activity_module_id)) {
      if (to.path.indexOf('/activity/') !== -1 || to.path.indexOf('/setting/region') !== -1) {
        next('/');
        return;
      }
    }
  }

  if (is_logged_on && to.path.indexOf('/login') !== -1) {
    next('/');
    return;
  }
});

export default router;
